export default __webpack_public_path__ + "static/media/6_Intro.9f791230.mp4";